var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"offers-page"},[_c('div',{staticClass:"offers-page-header"},[_c('offers-page-header')],1),_c('div',{staticClass:"offers-body"},[_c('offers-body')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }